import { viewPortBp } from "features/common/constants";
import { useState, useEffect, useMemo } from "react";

interface IViewPort {
  sizeS: boolean;
  sizeM: boolean;
  sizeL: boolean;
  minWidthS: boolean;
  minWidthM: boolean;
  minWidthL: boolean;
  minWidthXL: boolean;
  width: number;
}

export const useViewPort = (): IViewPort => {
  const getWidth = () =>
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  const [width, setWidth] = useState(getWidth());

  useEffect(() => {
    let timeoutId: number;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => setWidth(getWidth()), 150);
    };
    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  const sizeS = width <= viewPortBp.s;
  const sizeM = width > viewPortBp.s && width <= viewPortBp.m;
  const sizeL = width > viewPortBp.m;

  const minWidthS = useMemo(() => width > viewPortBp.s, [width]);
  const minWidthM = useMemo(() => width > viewPortBp.m, [width]);
  const minWidthL = useMemo(() => width > viewPortBp.l, [width]);
  const minWidthXL = useMemo(() => width > viewPortBp.xl, [width]);

  return {
    sizeS,
    sizeM,
    sizeL,
    minWidthS,
    minWidthM,
    minWidthL,
    minWidthXL,
    width
  };
};
